export default "__VITE_ASSET__hoNHMOGJ__"